<template>
    <div>
        <!-- start page title area-->
        <div class="page-title-area ptb-100">
            <div class="container">
                <div class="page-title-content">
                    <h1>{{$t('join_us_alt')}}</h1>
                </div>
			</div>
			<div class="bg-image">
				<img :src="banner_image" >
			</div>
        </div>
        <!-- end page title area -->

        <!-- start career single area -->
        <div class="career-single-area pt-70 pb-70 ">
            <!-- start career section -->
            <section id="career" class="career-section pb-70 d-none">
                <div class="container">
                    <div class="top-content">
                        <div class="title">
                            <span class="sub-title">{{ locale === 'ar' ? data.label_ar : data.label_en }}</span>
                            <h2>{{ locale === 'ar' ? data.sub_label_ar : data.sub_label_en }}</h2>
                        </div>
                        <form id="searchForm" >
                            <div class="form-row">
                                <div class="col-md-10 col-12">
                                    <input type="text" name="name" v-model="search_key" class="form-control" id="name" required :placeholder="$t('enter_job_title')" />
                                </div>
                                <div class="col-md-2 col-6">
                                    <button type="button" @click="search" class="primary-btn">{{$t("search")}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="row">
                        <div v-for="(data, index) in content" :key="index" class="col-lg-4 col-md-6">
                            <div class="item-single mb-30">
                                <h3><a href="javascript:void(0)">{{(locale == 'ar') ? data.arabic_title : data.english_title}}</a></h3>
                                <p>
                                    <read-more :more-str="$t('read_more')" :text="(locale == 'ar') ? data.arabic_short_description : data.english_short_description" link="#" :less-str="$t('read_less')" :max-chars="70"></read-more>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div class="content-area d-none">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-7 col-md-12">
                            <div class="content mb-30">
                                <h2>{{recruitment_process.title}}</h2>
                                <p v-html="recruitment_process.description" >
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-12">
                            <div class="image mb-30">
                                <img :src="recruitment_process.image">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end career section -->
            <hr>
            <!-- start appointment area -->
            <div id="appointment" class="appointment-area mt-30 pb-70">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-8">
                            <div class="content">
                                <span class="sub-title">{{ locale === 'ar' ? data.form_label_ar : data.form_label_en }}</span>
                                <h2>{{ locale === 'ar' ? data.form_sub_label_ar : data.form_sub_label_en }}</h2>
                            </div>
                            <template>
                            <div class="career-form-wrapper" ref="careerForm">
                                    <!-- Success Modal -->
                                    <div v-if="showSuccessModal" class="cf-modal-overlay">
                                        <div class="cf-modal">
                                            <div class="cf-modal-icon">
                                                <i class="fa fa-check-circle"></i>
                                            </div>
                                            <h3>{{ $t('form_submitted') }}</h3>
                                            <p>{{ $t('form_submitted_detail') }}</p>
                                            <button type="button" class="primary-btn" @click="goToHome">
                                                {{ $t('back_to_home') }}
                                            </button>
                                        </div>
                                    </div>

                                    <!-- Error Modal -->
                                    <div v-if="showErrorModal" class="cf-modal-overlay" @click.self="closeErrorModal">
                                        <div class="cf-modal cf-modal-error">
                                            <button type="button" class="cf-modal-close" :aria-label="$t('close') || 'Close'" @click="closeErrorModal">
                                                <i class="fa fa-times"></i>
                                            </button>
                                            <div class="cf-modal-icon cf-modal-icon-error">
                                                <i class="fa fa-exclamation-circle"></i>
                                            </div>
                                            <h3>{{ errorModalMessage }}</h3>
                                            <button type="button" class="primary-btn" @click="closeErrorModal">
                                                {{ $t('close') || 'Close' }}
                                            </button>
                                        </div>
                                    </div>
                                <form @submit="onSubmit" @keydown.enter.prevent="handleEnterKey" id="contactForm" novalidate>

                                    <!-- Global status banners -->
                                    <div v-if="errors.success" class="cf-alert cf-alert-success">{{ errors.success }}</div>

                                    <!-- Stepper -->
                                    <div class="cf-stepper">
                                        <div
                                            v-for="(step, index) in steps"
                                            :key="index"
                                            class="cf-step"
                                            :class="{ active: currentStep === index, done: currentStep > index }"
                                            @click="goToStep(index)"
                                        >
                                            <span class="cf-step-circle">
                                                <i v-if="currentStep > index" class="fa fa-check"></i>
                                                <template v-else>{{ index + 1 }}</template>
                                            </span>
                                            <span class="cf-step-label">{{ $t(step.labelKey) }}</span>
                                        </div>
                                    </div>

                                    <!-- STEP 1: Personal Details -->
                                    <div v-show="currentStep === 0" class="cf-panel">
                                        <h4 class="cf-panel-title">{{ $t('basic_info') }}</h4>
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('full_name') }} <span class="req">*</span></label>
                                                    <input type="text" class="form-control" :class="{ 'is-invalid': errors.name }" v-model="form.name" :placeholder="$t('full_name')" />
                                                    <small v-if="errors.name" class="cf-error">{{ errors.name }}</small>
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('date_of_birth') }} <span class="req">*</span></label>
                                                    <input type="date" class="form-control" :class="{ 'is-invalid': errors.date_of_birth }" v-model="form.date_of_birth" :max="maxDob" />
                                                    <small v-if="errors.date_of_birth" class="cf-error">{{ errors.date_of_birth }}</small>
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('nationality') }} <span class="req">*</span></label>
                                                    <div class="select-box">
                                                        <select v-model="form.nationality" class="form-control" :class="{ 'is-invalid': errors.nationality }">
                                                            <option value="" disabled selected>{{ $t('select_nationality') }}</option>
                                                            <option v-for="(c, i) in country_list" :key="i" :value="c.name">{{ c.name }}</option>
                                                        </select>
                                                    </div>
                                                    <small v-if="errors.nationality" class="cf-error">{{ errors.nationality }}</small>
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('current_residence_location') }} <span class="req">*</span></label>
                                                    <div class="select-box">
                                                        <select v-model="form.current_residence_location" class="form-control" :class="{ 'is-invalid': errors.current_residence_location }">
                                                            <option value="" disabled selected>{{ $t('select_country') }}</option>
                                                            <option v-for="(c, i) in country_list" :key="i" :value="c.name">{{ c.name }}</option>
                                                        </select>
                                                    </div>
                                                    <small v-if="errors.current_residence_location" class="cf-error">{{ errors.current_residence_location }}</small>
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('mobile_number') }} <span class="req">*</span></label>
                                                    <div class="phone-group">
                                                        <select v-model="form.phone_country_code" class="form-control">
                                                            <option value="" disabled selected>{{ $t('select_code') }}</option>
                                                            <option v-for="(c, i) in country_list" :key="i" :value="'+' + c.phone">
                                                                {{ c.name }} (+{{ c.phone }})
                                                            </option>
                                                        </select>
                                                        <input type="text" @keypress="isNumber($event)" class="form-control" :class="{ 'is-invalid': errors.phone }" v-model="form.phone" :placeholder="$t('phone_number')" />
                                                    </div>
                                                    <small v-if="errors.phone" class="cf-error">{{ errors.phone }}</small>
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('email_address') }} <span class="req">*</span></label>
                                                    <input type="email" class="form-control" :class="{ 'is-invalid': errors.email }" v-model="form.email" :placeholder="$t('email_address')" />
                                                    <small v-if="errors.email" class="cf-error">{{ errors.email }}</small>
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('gender') }} <span class="req">*</span></label>
                                                    <div class="cf-radio-group">
                                                        <label class="cf-radio-pill" :class="{ active: form.gender === 'male' }">
                                                            <input type="radio" value="male" v-model="form.gender" />
                                                            <span>{{ $t('male') }}</span>
                                                        </label>
                                                        <label class="cf-radio-pill" :class="{ active: form.gender === 'female' }">
                                                            <input type="radio" value="female" v-model="form.gender" />
                                                            <span>{{ $t('female') }}</span>
                                                        </label>
                                                    </div>
                                                    <small v-if="errors.gender" class="cf-error">{{ errors.gender }}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- STEP 2: Education & Experience -->
                                    <div v-show="currentStep === 1" class="cf-panel">
                                        <h4 class="cf-panel-title">{{ $t('experience') }}</h4>
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('years_of_experience') }}</label>
                                                    <input type="text" @keypress="isNumber($event)" class="form-control" v-model="form.years_of_experience" :placeholder="$t('years_of_experience')" />
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('highest_education') }} <span class="req">*</span></label>
                                                    <div class="select-box">
                                                        <select v-model="form.highest_education" class="form-control" :class="{ 'is-invalid': errors.highest_education }">
                                                            <option value="" disabled selected>{{ $t('select_education') }}</option>
                                                            <option value="below_high_school">{{ $t('below_high_school') }}</option>
                                                            <option value="high_school">{{ $t('high_school') }}</option>
                                                            <option value="diploma">{{ $t('diploma') }}</option>
                                                            <option value="bachelors_degree">{{ $t('bachelors_degree') }}</option>
                                                            <option value="masters_degree">{{ $t('masters_degree') }}</option>
                                                            <option value="phd_doctorate">{{ $t('phd_doctorate') }}</option>
                                                        </select>
                                                    </div>
                                                    <small v-if="errors.highest_education" class="cf-error">{{ errors.highest_education }}</small>
                                                </div>
                                            </div>

                                            <div class="col-lg-12 col-md-12">
                                                <div class="form-group">
                                                    <label>{{ $t('majors') }}</label>
                                                    <input type="text" class="form-control" :class="{ 'is-invalid': errors.majors }" v-model="form.majors" :placeholder="$t('majors')" />
                                                    <small v-if="errors.majors" class="cf-error">{{ errors.majors }}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- STEP 3: Last Employment -->
                                    <div v-show="currentStep === 2" class="cf-panel">
                                        <h4 class="cf-panel-title">{{ $t('last_employment') }}</h4>
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('last_company_worked') }}</label>
                                                    <input type="text" class="form-control" v-model="form.last_company_worked" :placeholder="$t('last_company_worked')" />
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('last_company_country') }}</label>
                                                    <div class="select-box">
                                                        <select v-model="form.last_company_country" class="form-control">
                                                            <option value="" disabled selected>{{ $t('select_country') }}</option>
                                                            <option v-for="(c, i) in country_list" :key="i" :value="c.name">{{ c.name }}</option>   
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('job_title') }}</label>
                                                    <input type="text" class="form-control" v-model="form.job_title" :placeholder="$t('job_title')" />
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('employment_period') }}</label>
                                                    <input type="text" class="form-control" v-model="form.employment_period" :placeholder="$t('employment_period_hint')" />
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('last_salary') }}</label>
                                                    <input type="text" @keypress="isNumber($event)" class="form-control" v-model="form.last_salary" :placeholder="$t('last_salary')" />
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('notice_period_to_join') }}</label>
                                                    <div class="select-box">
                                                        <select v-model="form.notice_period" class="form-control" :class="{ 'is-invalid': errors.notice_period }">
                                                            <option value="" disabled selected>{{ $t('select_notice_period') }}</option>
                                                            <option value="immediately">{{ $t('immediately') }}</option>
                                                            <option value="less_than_1_month">{{ $t('less_than_1_month') }}</option>
                                                            <option value="1_month">{{ $t('one_month') }}</option>
                                                            <option value="3_months">{{ $t('three_months') }}</option>
                                                        </select>
                                                    </div>
                                                    <small v-if="errors.notice_period" class="cf-error">{{ errors.notice_period }}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- STEP 4: Documents -->
                                    <div v-show="currentStep === 3" class="cf-panel">
                                        <h4 class="cf-panel-title">{{ $t('documents') }}</h4>
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('upload_your_resume') }} <span class="req">*</span></label>
                                                    <div class="cf-upload" :class="{ filled: form.file, 'is-invalid': errors.file }" @click="$refs.resumeInput.click()">
                                                        <i class="fa fa-cloud-upload-alt"></i>
                                                        <span v-if="!form.file">{{ $t('choose_file') }}</span>
                                                        <span v-else class="cf-filename">{{ form.file.name }}</span>
                                                    </div>
                                                    <input ref="resumeInput" type="file" class="d-none"
                                                        accept=".pdf,application/pdf"
                                                        @change="readFile" />
                                                    <small class="form-text text-muted">{{ $t('resume_upload_hint') }}</small>
                                                    <small v-if="errors.file" class="cf-error">{{ errors.file }}</small>
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('upload_certificate') }}</label>
                                                    <div class="cf-upload" :class="{ filled: form.certificate_file, 'is-invalid': errors.certificate_file }" @click="$refs.certInput.click()">
                                                        <i class="fa fa-cloud-upload-alt"></i>
                                                        <span v-if="!form.certificate_file">{{ $t('choose_file') }}</span>
                                                        <span v-else class="cf-filename">{{ form.certificate_file.name }}</span>
                                                    </div>
                                                    <input ref="certInput" type="file" class="d-none"
                                                        accept=".pdf,application/pdf"
                                                        @change="readCertificateFile" />
                                                    <small class="form-text text-muted">{{ $t('certificates_upload_hint') }}</small>
                                                    <small v-if="errors.certificate_file" class="cf-error">{{ errors.certificate_file }}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Navigation -->
                                    <div class="cf-nav">
                                        <button type="button" class="secondary-btn" v-if="currentStep > 0" @click="prevStep">
                                            {{ $t('back') }}
                                        </button>
                                        <div class="cf-nav-spacer"></div>
                                        <button type="button" class="primary-btn" key="next-btn" v-if="currentStep < steps.length - 1" @click="nextStep">
                                            {{ $t('next') }}
                                        </button>
                                        <button type="submit" class="primary-btn" key="apply-btn" v-else :disabled="submitting">
                                            {{ submitting ? $t('submitting') : $t('apply') }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                            </template>

                        </div>
                    </div>
                </div>
            </div>
            <!-- end contact area -->
        </div>
        <!-- start career single area -->
    </div>
</template>
<script>
import axios from "../axios";
import { mapActions } from 'vuex';

export default {
    name: 'Career',

    data() {
        return {
            data: {},
            hide_index: 0,
            content: [],
            recruitment_process: {},
            original_content: [],
            banner_image: '',
            file_type: '',
            search_key: '',
            locale: localStorage.getItem("locale"),
            currentStep: 0,
            submitting: false,
            errors: {},
            showSuccessModal: false,
            showErrorModal: false,
            errorModalMessage: '',
            steps: [
                { labelKey: 'basic_info' },
                { labelKey: 'education_experience' },
                { labelKey: 'last_employment' },
                { labelKey: 'documents' }
            ],

            country_list : [
                { name: "Afghanistan", phone: 93 },
                { name: "Åland Islands", phone: 358 },
                { name: "Albania", phone: 355 },
                { name: "Algeria", phone: 213 },
                { name: "American Samoa", phone: 1 },
                { name: "Andorra", phone: 376 },
                { name: "Angola", phone: 244 },
                { name: "Anguilla", phone: 1 },
                { name: "Antarctica", phone: 672 },
                { name: "Antigua and Barbuda", phone: 1 },
                { name: "Argentina", phone: 54 },
                { name: "Armenia", phone: 374 },
                { name: "Aruba", phone: 297 },
                { name: "Australia", phone: 61 },
                { name: "Austria", phone: 43 },
                { name: "Azerbaijan", phone: 994 },
                { name: "Bahamas", phone: 1 },
                { name: "Bahrain", phone: 973 },
                { name: "Bangladesh", phone: 880 },
                { name: "Barbados", phone: 1 },
                { name: "Belarus", phone: 375 },
                { name: "Belgium", phone: 32 },
                { name: "Belize", phone: 501 },
                { name: "Benin", phone: 229 },
                { name: "Bermuda", phone: 1 },
                { name: "Bhutan", phone: 975 },
                { name: "Bolivia (Plurinational State of)", phone: 591 },
                { name: "Bosnia and Herzegovina", phone: 387 },
                { name: "Botswana", phone: 267 },
                { name: "Bouvet Island", phone: 55 },
                { name: "Brazil", phone: 55 },
                { name: "British Indian Ocean Territory", phone: 246 },
                { name: "Brunei Darussalam", phone: 673 },
                { name: "Bulgaria", phone: 359 },
                { name: "Burkina Faso", phone: 226 },
                { name: "Burundi", phone: 257 },
                { name: "Cabo Verde", phone: 238 },
                { name: "Cambodia", phone: 855 },
                { name: "Cameroon", phone: 237 },
                { name: "Canada", phone: 1 },
                { name: "Caribbean Netherlands", phone: 599 },
                { name: "Cayman Islands", phone: 1 },
                { name: "Central African Republic", phone: 236 },
                { name: "Chad", phone: 235 },
                { name: "Chile", phone: 56 },
                { name: "China", phone: 86 },
                { name: "Christmas Island", phone: 61 },
                { name: "Cocos (Keeling) Islands", phone: 61 },
                { name: "Colombia", phone: 57 },
                { name: "Comoros", phone: 269 },
                { name: "Congo", phone: 242 },
                { name: "Congo, Democratic Republic of the", phone: 243 },
                { name: "Cook Islands", phone: 682 },
                { name: "Costa Rica", phone: 506 },
                { name: "Croatia", phone: 385 },
                { name: "Cuba", phone: 53 },
                { name: "Curaçao", phone: 599 },
                { name: "Cyprus", phone: 357 },
                { name: "Czech Republic", phone: 420 },
                { name: "Côte d'Ivoire", phone: 225 },
                { name: "Denmark", phone: 45 },
                { name: "Djibouti", phone: 253 },
                { name: "Dominica", phone: 1 },
                { name: "Dominican Republic", phone: 1 },
                { name: "Ecuador", phone: 593 },
                { name: "Egypt", phone: 20 },
                { name: "El Salvador", phone: 503 },
                { name: "Equatorial Guinea", phone: 240 },
                { name: "Eritrea", phone: 291 },
                { name: "Estonia", phone: 372 },
                { name: "Eswatini (Swaziland)", phone: 268 },
                { name: "Ethiopia", phone: 251 },
                { name: "Falkland Islands (Malvinas)", phone: 500 },
                { name: "Faroe Islands", phone: 298 },
                { name: "Fiji", phone: 679 },
                { name: "Finland", phone: 358 },
                { name: "France", phone: 33 },
                { name: "French Guiana", phone: 594 },
                { name: "French Polynesia", phone: 689 },
                { name: "French Southern Territories", phone: 262 },
                { name: "Gabon", phone: 241 },
                { name: "Gambia", phone: 220 },
                { name: "Georgia", phone: 995 },
                { name: "Germany", phone: 49 },
                { name: "Ghana", phone: 233 },
                { name: "Gibraltar", phone: 350 },
                { name: "Greece", phone: 30 },
                { name: "Greenland", phone: 299 },
                { name: "Grenada", phone: 1 },
                { name: "Guadeloupe", phone: 590 },
                { name: "Guam", phone: 1 },
                { name: "Guatemala", phone: 502 },
                { name: "Guernsey", phone: 44 },
                { name: "Guinea", phone: 224 },
                { name: "Guinea-Bissau", phone: 245 },
                { name: "Guyana", phone: 592 },
                { name: "Haiti", phone: 509 },
                { name: "Heard Island and Mcdonald Islands", phone: 61 },
                { name: "Honduras", phone: 504 },
                { name: "Hong Kong", phone: 852 },
                { name: "Hungary", phone: 36 },
                { name: "Iceland", phone: 354 },
                { name: "India", phone: 91 },
                { name: "Indonesia", phone: 62 },
                { name: "Iran", phone: 98 },
                { name: "Iraq", phone: 964 },
                { name: "Ireland", phone: 353 },
                { name: "Isle of Man", phone: 44 },
                { name: "Israel", phone: 972 },
                { name: "Italy", phone: 39 },
                { name: "Jamaica", phone: 1 },
                { name: "Japan", phone: 81 },
                { name: "Jersey", phone: 44 },
                { name: "Jordan", phone: 962 },
                { name: "Kazakhstan", phone: 7 },
                { name: "Kenya", phone: 254 },
                { name: "Kiribati", phone: 686 },
                { name: "Korea, North", phone: 850 },
                { name: "Korea, South", phone: 82 },
                { name: "Kosovo", phone: 383 },
                { name: "Kuwait", phone: 965 },
                { name: "Kyrgyzstan", phone: 996 },
                { name: "Lao People's Democratic Republic", phone: 856 },
                { name: "Latvia", phone: 371 },
                { name: "Lebanon", phone: 961 },
                { name: "Lesotho", phone: 266 },
                { name: "Liberia", phone: 231 },
                { name: "Libya", phone: 218 },
                { name: "Liechtenstein", phone: 423 },
                { name: "Lithuania", phone: 370 },
                { name: "Luxembourg", phone: 352 },
                { name: "Macao", phone: 853 },
                { name: "Macedonia North", phone: 389 },
                { name: "Madagascar", phone: 261 },
                { name: "Malawi", phone: 265 },
                { name: "Malaysia", phone: 60 },
                { name: "Maldives", phone: 960 },
                { name: "Mali", phone: 223 },
                { name: "Malta", phone: 356 },
                { name: "Marshall Islands", phone: 692 },
                { name: "Martinique", phone: 596 },
                { name: "Mauritania", phone: 222 },
                { name: "Mauritius", phone: 230 },
                { name: "Mayotte", phone: 262 },
                { name: "Mexico", phone: 52 },
                { name: "Micronesia", phone: 691 },
                { name: "Moldova", phone: 373 },
                { name: "Monaco", phone: 377 },
                { name: "Mongolia", phone: 976 },
                { name: "Montenegro", phone: 382 },
                { name: "Montserrat", phone: 1 },
                { name: "Morocco", phone: 212 },
                { name: "Mozambique", phone: 258 },
                { name: "Myanmar (Burma)", phone: 95 },
                { name: "Namibia", phone: 264 },
                { name: "Nauru", phone: 674 },
                { name: "Nepal", phone: 977 },
                { name: "Netherlands", phone: 31 },
                { name: "New Caledonia", phone: 687 },
                { name: "New Zealand", phone: 64 },
                { name: "Nicaragua", phone: 505 },
                { name: "Niger", phone: 227 },
                { name: "Nigeria", phone: 234 },
                { name: "Niue", phone: 683 },
                { name: "Norfolk Island", phone: 672 },
                { name: "Northern Mariana Islands", phone: 1 },
                { name: "Norway", phone: 47 },
                { name: "Oman", phone: 968 },
                { name: "Pakistan", phone: 92 },
                { name: "Palau", phone: 680 },
                { name: "Palestine", phone: 970 },
                { name: "Panama", phone: 507 },
                { name: "Papua New Guinea", phone: 675 },
                { name: "Paraguay", phone: 595 },
                { name: "Peru", phone: 51 },
                { name: "Philippines", phone: 63 },
                { name: "Pitcairn Islands", phone: 64 },
                { name: "Poland", phone: 48 },
                { name: "Portugal", phone: 351 },
                { name: "Puerto Rico", phone: 1 },
                { name: "Qatar", phone: 974 },
                { name: "Reunion", phone: 262 },
                { name: "Romania", phone: 40 },
                { name: "Russian Federation", phone: 7 },
                { name: "Rwanda", phone: 250 },
                { name: "Saint Barthelemy", phone: 590 },
                { name: "Saint Helena", phone: 290 },
                { name: "Saint Kitts and Nevis", phone: 1 },
                { name: "Saint Lucia", phone: 1 },
                { name: "Saint Martin", phone: 590 },
                { name: "Saint Pierre and Miquelon", phone: 508 },
                { name: "Saint Vincent and the Grenadines", phone: 1 },
                { name: "Samoa", phone: 685 },
                { name: "San Marino", phone: 378 },
                { name: "Sao Tome and Principe", phone: 239 },
                { name: "Saudi Arabia", phone: 966 },
                { name: "Senegal", phone: 221 },
                { name: "Serbia", phone: 381 },
                { name: "Seychelles", phone: 248 },
                { name: "Sierra Leone", phone: 232 },
                { name: "Singapore", phone: 65 },
                { name: "Sint Maarten", phone: 1 },
                { name: "Slovakia", phone: 421 },
                { name: "Slovenia", phone: 386 },
                { name: "Solomon Islands", phone: 677 },
                { name: "Somalia", phone: 252 },
                { name: "South Africa", phone: 27 },
                { name: "South Georgia and the South Sandwich Islands", phone: 500 },
                { name: "South Sudan", phone: 211 },
                { name: "Spain", phone: 34 },
                { name: "Sri Lanka", phone: 94 },
                { name: "Sudan", phone: 249 },
                { name: "Suriname", phone: 597 },
                { name: "Svalbard and Jan Mayen", phone: 47 },
                { name: "Sweden", phone: 46 },
                { name: "Switzerland", phone: 41 },
                { name: "Syria", phone: 963 },
                { name: "Taiwan", phone: 886 },
                { name: "Tajikistan", phone: 992 },
                { name: "Tanzania", phone: 255 },
                { name: "Thailand", phone: 66 },
                { name: "Timor-Leste", phone: 670 },
                { name: "Togo", phone: 228 },
                { name: "Tokelau", phone: 690 },
                { name: "Tonga", phone: 676 },
                { name: "Trinidad and Tobago", phone: 1 },
                { name: "Tunisia", phone: 216 },
                { name: "Turkey (Türkiye)", phone: 90 },
                { name: "Turkmenistan", phone: 993 },
                { name: "Turks and Caicos Islands", phone: 1 },
                { name: "Tuvalu", phone: 688 },
                { name: "U.S. Outlying Islands", phone: 1 },
                { name: "Uganda", phone: 256 },
                { name: "Ukraine", phone: 380 },
                { name: "United Arab Emirates", phone: 971 },
                { name: "United Kingdom", phone: 44 },
                { name: "United States", phone: 1 },
                { name: "Uruguay", phone: 598 },
                { name: "Uzbekistan", phone: 998 },
                { name: "Vanuatu", phone: 678 },
                { name: "Vatican City Holy See", phone: 39 },
                { name: "Venezuela", phone: 58 },
                { name: "Vietnam", phone: 84 },
                { name: "Virgin Islands, British", phone: 1 },
                { name: "Virgin Islands, U.S", phone: 1 },
                { name: "Wallis and Futuna", phone: 681 },
                { name: "Western Sahara", phone: 212 },
                { name: "Yemen", phone: 967 },
                { name: "Zambia", phone: 260 },
                { name: "Zimbabwe", phone: 263 }
            ],

            form: {
                name: "",
                date_of_birth: "",
                nationality: "",
                current_residence_location: "",
                phone_country_code: "",
                phone: "",
                email: "",
                gender: "",
                years_of_experience: "",
                highest_education: "",
                majors: "",
                last_company_worked: "",
                last_company_country: "",
                job_title: "",
                employment_period: "",
                last_salary: "",
                notice_period: "",
                file: null,
                certificate_file: null
            }
        }
    },

    computed: {
        maxDob() {
            return new Date().toISOString().split('T')[0];
        }
    },

    watch: {
        // Live-clear each field's error the moment it becomes valid, instead of
        // waiting for the user to click Next/Back again. Only re-checks fields
        // that already have an error showing, so we don't nag before first submit.
        'form.name'(){ this.recheckField('name'); },
        'form.date_of_birth'(){ this.recheckField('date_of_birth'); },
        'form.nationality'(){ this.recheckField('nationality'); },
        'form.current_residence_location'(){ this.recheckField('current_residence_location'); },
        'form.phone'(){ this.recheckField('phone'); },
        'form.email'(){ this.recheckField('email'); },
        'form.gender'(){ this.recheckField('gender'); },
        'form.highest_education'(){ this.recheckField('highest_education'); },
        'form.majors'(){ this.recheckField('majors'); },
        'form.notice_period'(){ this.recheckField('notice_period'); }
    },

    methods:{
        ...mapActions("navigation", ["setNavLink"]),
        ...mapActions("navigation", ["setNavItem"]),

        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        search(){
            const search = this.search_key.toLowerCase().trim();
            if (!search) {
                this.content = this.original_content;
                return false;
            }
            this.content = this.original_content.filter(item => {
                if(this.locale == 'ar'){
                    return item.arabic_title.toLowerCase().includes(search);
                }else{
                    return item.english_title.toLowerCase().includes(search);
                }
            });
        },

        hideSmallHeading(index){
            if(index != this.hide_index){
                this.hide_index = index
            }else{
                this.hide_index = 0
            }
        },

        goToStep(index){
            if(index <= this.currentStep){
                this.currentStep = index;
                return;
            }
            for(let i = this.currentStep; i < index; i++){
                if(!this.validateStep(i)){
                    // Jump to the first step that failed so its errors are visible
                    this.currentStep = i;
                    this.focusFirstInvalidField();
                    return;
                }
            }
            this.currentStep = index;
        },

        nextStep(){
            if(!this.validateStep(this.currentStep)){
                this.focusFirstInvalidField();
                return;
            }
            this.currentStep++;
        },

        prevStep(){
            this.currentStep--;
        },

        handleEnterKey(){
            if(this.currentStep < this.steps.length - 1){
                this.nextStep();
            }
        },

        // Field names owned by each step, used to clear/replace only that step's
        // errors without touching errors that belong to other steps
        stepFields(step){
            if(step === 0) return ['name', 'date_of_birth', 'nationality', 'current_residence_location', 'phone', 'email', 'gender'];
            if(step === 1) return ['highest_education'];
            if(step === 2) return [];
            return [];
        },

        // Single source of truth for a field's validity. Returns an error message
        // string if invalid, or '' if valid. Reused by validateStep (button clicks)
        // and recheckField (live re-check as the user types/selects).
        validateField(field){
            const f = this.form;
            switch(field){
                case 'name':
                    return f.name.trim() ? '' : (this.$t('name_required') || 'Please enter your full name.');
                case 'date_of_birth':
                    return f.date_of_birth ? '' : (this.$t('dob_required') || 'Please enter your date of birth.');
                case 'nationality':
                    return f.nationality ? '' : (this.$t('nationality_required') || 'Please select your nationality.');
                case 'current_residence_location':
                    return f.current_residence_location ? '' : (this.$t('residence_required') || 'Please select your current residence.');
                case 'phone':
                    return f.phone.trim() ? '' : (this.$t('phone_required') || 'Please enter your mobile number.');
                case 'email':
                    return (f.email.trim() && /^\S+@\S+\.\S+$/.test(f.email)) ? '' : (this.$t('valid_email_required') || 'Please enter a valid email address.');
                case 'gender':
                    return f.gender ? '' : (this.$t('gender_required') || 'Please select your gender.');
                case 'highest_education':
                    return f.highest_education ? '' : (this.$t('education_required') || 'Please select your highest education.');
                default:
                    return '';
            }
        },

        // Validates every field belonging to a step and merges the result into
        // this.errors by reassigning the whole object, so Vue 2's reactivity
        // picks up new/removed keys reliably.
        validateStep(step){
            const merged = { ...this.errors };
            let valid = true;

            this.stepFields(step).forEach(field => {
                const msg = this.validateField(field);
                if(msg){
                    merged[field] = msg;
                    valid = false;
                } else {
                    delete merged[field];
                }
            });

            this.errors = merged;
            return valid;
        },

        // Called by the watchers above on every keystroke/selection change.
        // Only re-checks a field if it currently has an error showing — this
        // way errors don't appear before the user's first Next/Submit attempt,
        // but once shown, they clear the instant the field becomes valid.
        recheckField(field){
            if(this.errors[field] === undefined) return;

            const msg = this.validateField(field);
            const merged = { ...this.errors };
            if(msg){
                merged[field] = msg;
            } else {
                delete merged[field];
            }
            this.errors = merged;
        },

        // Validates ALL required steps at once, accumulating errors from every
        // step (used as the final guard right before submit)
        validateAllSteps(){
            let valid = true;
            [0, 1, 2].forEach(step => {
                if(!this.validateStep(step)) valid = false;
            });
            return valid;
        },

        validateFile(file, field, allowSizeMb = 2){
            const allowed_types = ['application/pdf'];
            const max_size = allowSizeMb * 1024 * 1024;

            if(!allowed_types.includes(file.type)){
                this.$set(this.errors, field, this.$t('invalid_file_type') || 'Only PDF files are allowed.');
                return false;
            }
            if(file.size > max_size){
                this.$set(this.errors, field, this.$t('file_too_large') || `File size must not exceed ${allowSizeMb}MB.`);
                return false;
            }
            this.$delete(this.errors, field);
            return true;
        },

        readFile(e){
            const file_data = e.target.files[0];
            if(!file_data){ this.form.file = null; return; }
            if(!this.validateFile(file_data, 'file')){
                e.target.value = '';
                this.form.file = null;
                return;
            }
            this.form.file = file_data;
        },

        readCertificateFile(e){
            const file_data = e.target.files[0];
            if(!file_data){ this.form.certificate_file = null; return; }
            if(!this.validateFile(file_data, 'certificate_file')){
                e.target.value = '';
                this.form.certificate_file = null;
                return;
            }
            this.form.certificate_file = file_data;
        },

        goToHome(){
            this.showSuccessModal = false;
            this.$router.push('/');
        },

        // Opens the error modal with a given message. Used for submit-level
        // failures (already-applied, server error, etc.) as opposed to
        // per-field validation errors, which stay inline under their inputs.
        openErrorModal(message){
            this.errorModalMessage = message;
            this.showErrorModal = true;
        },

        closeErrorModal(){
            this.showErrorModal = false;
            this.errorModalMessage = '';
        },

        // Smoothly scrolls the form into view. Previously called from onSubmit's
        // error paths but never defined, which threw a TypeError on every failed submit.
        scrollToFormTop(){
            this.$nextTick(() => {
                if(this.$refs.careerForm){
                    this.$refs.careerForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        },

        // Scrolls to and focuses the first field currently showing a validation
        // error, so the user lands directly on what needs fixing instead of
        // having to hunt for it. Waits for Vue to finish re-rendering (currentStep
        // change, error messages) before querying the DOM.
        focusFirstInvalidField(){
            this.$nextTick(() => {
                if(!this.$refs.careerForm) return;
                const el = this.$refs.careerForm.querySelector('.is-invalid, .cf-upload.is-invalid');
                if(!el) return;

                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                if(typeof el.focus === 'function'){
                    el.focus({ preventScroll: true });
                }
            });
        },

        onSubmit(e){
            e.preventDefault();

            // Hard guard: only allow actual submission on the final step
            if(this.currentStep !== this.steps.length - 1){
                this.nextStep();
                return;
            }

            // Validate every required step before allowing submission
            if(!this.validateAllSteps()){
                if(this.errors.name || this.errors.date_of_birth || this.errors.nationality ||
                   this.errors.current_residence_location || this.errors.phone || this.errors.email || this.errors.gender){
                    this.currentStep = 0;
                } else if(this.errors.highest_education){
                    this.currentStep = 1;
                }
                this.focusFirstInvalidField();
                return;
            }

            if(!this.form.file){
                this.$set(this.errors, 'file', this.$t('resume_required') || 'Please upload your resume (PDF).');
                this.currentStep = 3;
                this.focusFirstInvalidField();
                return;
            }

            this.submitting = true;

            let formData = new FormData();
            Object.keys(this.form).forEach(key => {
                if(this.form[key] !== null && this.form[key] !== undefined){
                    formData.append(key, this.form[key]);
                }
            });

            axios.post(`careers-form`, formData, {headers: {"Content-Type": "multipart/form-data"}})
            .then(response => {
                if(response.data.status){
                    this.errors = {};
                    e.target.reset();
                    this.form = {
                        name: "", 
                        date_of_birth: "", 
                        nationality: "", 
                        current_residence_location: "",
                        phone_country_code: "", 
                        phone: "", 
                        email: "", 
                        gender: "", 
                        years_of_experience: "",
                        highest_education: "", 
                        majors: "", 
                        last_company_worked: "", 
                        last_company_country: "",
                        job_title: "", 
                        employment_period: "", 
                        last_salary: "", 
                        notice_period: "",
                        file: null, certificate_file: null
                    };
                    this.currentStep = 0;
                    this.showSuccessModal = true;
                }else{
                    // Surface the backend's own message (e.g. "You have already
                    // submitted an application") in the error modal instead of
                    // a generic inline banner.
                    this.currentStep = 0;
                    this.openErrorModal(
                        response.data.message || this.$t('invalid_form_details') || 'Invalid form details. Please check your inputs.'
                    );
                }
            })
            .catch(err => {
                console.log(err);
                if(err.response && err.response.status === 422 && err.response.data.errors){
                    const backendErrors = err.response.data.errors;
                    const merged = { ...this.errors };
                    Object.keys(backendErrors).forEach(key => {
                        merged[key] = backendErrors[key][0];
                    });
                    this.errors = merged;
                } else {
                    // err.response.message doesn't exist — the message lives at
                    // err.response.data.message. Fall back to a generic string
                    // only if the backend didn't send one.
                    const msg = (err.response && err.response.data && err.response.data.message)
                        || 'Something went wrong. Please try again.';
                    this.openErrorModal(msg);
                }
            })
            .finally(() => {
                this.submitting = false;
            })
        }
    },

    created() {
        this.setNavLink('join_us')
        this.setNavItem('')

        axios.get(`careers-list`)
        .then(response => {
            this.data = response.data.data
            this.original_content = response.data.data.content
            this.content = response.data.data.content
            this.recruitment_process = response.data.data.recruitment_process
            this.banner_image = response.data.data.banner_image
        })
        .catch(e => {
            console.error(e);
        })
    }
}
</script>

<style scoped>
.career-form-wrapper {
    max-width: 900px;
    margin: 0 auto;
}

/* Stepper */
.cf-stepper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    position: relative;
}
.cf-stepper::before {
    content: '';
    position: absolute;
    top: 18px;
    left: 0;
    right: 0;
    height: 2px;
    background: #e5e5e5;
    z-index: 0;
}
.cf-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    position: relative;
    z-index: 1;
    flex: 1;
}
.cf-step-circle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #e5e5e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: #999;
    transition: all 0.25s ease;
}
.cf-step.active .cf-step-circle {
    border-color: #f6921e;
    background: #f6921e;
    color: #fff;
}
.cf-step.done .cf-step-circle {
    border-color: #28a745;
    background: #28a745;
    color: #fff;
}
.cf-step-label {
    font-size: 13px;
    color: #999;
    text-align: center;
}
.cf-step.active .cf-step-label {
    color: #222;
    font-weight: 600;
}

/* Panels */
.cf-panel {
    animation: cfFadeIn 0.3s ease;
}
@keyframes cfFadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
}
.cf-panel-title {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    border-left: 3px solid #f6921e;
    padding-left: 12px;
}

.form-group {
    margin-bottom: 24px;
}
.form-group label {
    font-size: 13px;
    font-weight: 600;
    color: #555;
    margin-bottom: 6px;
    display: block;
}
.req {
    color: #d9534f;
}

/* Consistent field sizing */
.cf-panel .form-control {
    height: 44px;
    padding: 0 14px;
    line-height: 44px;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
}

.cf-panel input.form-control {
    padding: 10px 14px;
    line-height: normal;
}

.cf-panel .select-box {
    position: relative;
}

.cf-panel .select-box select.form-control {
    appearance: none;
    -webkit-appearance: none;
    padding-right: 36px;
}

.cf-panel .select-box::after {
    content: '';
    position: absolute;
    right: 16px;
    top: 50%;
    width: 8px;
    height: 8px;
    border-right: 2px solid #999;
    border-bottom: 2px solid #999;
    transform: translateY(-70%) rotate(45deg);
    pointer-events: none;
}

/* Gender row shouldn't leave a large gap below it before the nav divider */
.cf-radio-group {
    padding-top: 0;
    margin-bottom: 0;
}
.row > .col-lg-6:last-child .form-group,
.row > .col-lg-12:last-child .form-group {
    margin-bottom: 0;
}

.cf-panel {
    margin-bottom: 10px;
}

/* Inline error/alert styling — matches your theme's orange/navy palette */
.cf-error {
    display: block;
    color: #d9534f;
    font-size: 12px;
    margin-top: 4px;
}
.form-control.is-invalid {
    border-color: #d9534f;
}
.cf-alert {
    padding: 12px 16px;
    border-radius: 3px;
    margin-bottom: 20px;
    font-size: 14px;
}
.cf-alert-error {
    background: #fdecea;
    color: #d9534f;
    border: 1px solid #f5c2c0;
}
.cf-alert-success {
    background: #eafaf0;
    color: #28a745;
    border: 1px solid #b7ebc6;
}

/* Phone input group */
.phone-group {
    display: flex;
    gap: 8px;
}
.phone-group .form-control {
    height: 44px;
}
.phone-group select.form-control {
    max-width: 130px;
    flex-shrink: 0;
}
.cf-country-code {
    max-width: 90px;
    flex-shrink: 0;
}

/* Radio buttons */
.cf-radio-group {
    display: flex;
    gap: 12px;
    align-items: center;
    height: 100%;
    padding-top: 6px;
}
.cf-radio-pill {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 18px;
    border: 1.5px solid #e0e0e0;
    border-radius: 30px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: #666;
    margin-bottom: 0;
    box-sizing: border-box;
    transition: all 0.2s ease;
}
.cf-radio-pill input {
    display: none;
}
.cf-radio-pill:hover {
    border-color: #f6921e;
}
.cf-radio-pill.active {
    background: #f6921e;
    border-color: #f6921e;
    color: #fff;
}
.cf-radio {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-weight: 400;
    margin-bottom: 0;
}
.cf-radio input {
    width: 16px;
    height: 16px;
    cursor: pointer;
}

/* Upload boxes */
.cf-upload {
    border: 2px dashed #ccc;
    border-radius: 6px;
    padding: 18px 12px;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease;
    color: #888;
}
.cf-upload:hover {
    border-color: #f6921e;
    background: #fdf9ef;
}
.cf-upload.filled {
    border-color: #28a745;
    background: #f4fbf6;
    color: #28a745;
}
.cf-upload i {
    display: block;
    font-size: 22px;
    margin-bottom: 6px;
}
.cf-filename {
    word-break: break-all;
    font-size: 13px;
}

/* Error modal variant + close button (success modal styling assumed to
   already exist globally; these rules only add what's new for the error
   modal so they won't clash with it) */
.cf-modal {
    position: relative;
}
.cf-modal-close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    color: #999;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background 0.2s ease, color 0.2s ease;
}
.cf-modal-close:hover {
    background: #f5f5f5;
    color: #333;
}
.cf-modal-icon-error {
    color: #d9534f;
}
.cf-modal-error h3 {
    color: #d9534f;
}

/* Navigation buttons */
.cf-nav {
    display: flex;
    align-items: center;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #eee;
}
.cf-nav-spacer {
    flex: 1;
}
.cf-nav .primary-btn,
.cf-nav .secondary-btn {
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    margin: 0;
    line-height: 1;
    vertical-align: middle;
}

/* Responsive */
@media (max-width: 767px) {
    .cf-stepper {
        overflow-x: auto;
        justify-content: flex-start;
        gap: 24px;
        padding-bottom: 6px;
    }
    .cf-step-label {
        font-size: 11px;
        white-space: nowrap;
    }
    .phone-group {
        flex-direction: column;
    }
    .cf-country-code {
        max-width: 100%;
    }
    .cf-nav {
        flex-wrap: wrap;
        gap: 12px;
    }
    .cf-nav-spacer {
        display: none;
    }
    .cf-nav button {
        flex: 1;
    }
}
</style>